import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class TimeSheetCourierPlanTemplate extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/timeSheet/courier/template'
        super(store, path)
    }
}